module.exports = __webpack_public_path__ + "img/pbi4.828bb783.png";